
import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

export const useAutoStockManagement = () => {
  const [isProcessing, setIsProcessing] = useState(false);
  
  const autoDeactivateOnZeroStock = async (listingId: number, newStock: number) => {
    if (newStock > 0) return;
    
    setIsProcessing(true);
    try {
      const { error } = await supabase
        .from('listings')
        .update({ 
          is_active: false,
          last_active_at: new Date().toISOString()
        })
        .eq('id', listingId);
      
      if (error) throw error;
      
    } catch (error) {
      throw new Error('Error deactivating listing on zero stock');
    } finally {
      setIsProcessing(false);
    }
  };
  
  return {
    autoDeactivateOnZeroStock
  };
};
